import React from "react";

// Images
import FadeIn from "react-fade-in";
import nutsImg from "assets/nuts.jpg";
import seedsImg from "assets/seeds.jpg";
import beansImg from "assets/beans.jpg";

// Components
import Card from "components/layout/Card";
import A from "components/layout/Link";
import Intro from "components/Intro";
import Nav from "components/Nav";

// External resources
import LightenDarkenColor from "functions/LightenDarken.js";

import {
    colorNuts,
    colorBeans,
    colorSeeds,
} from "sass/partials/_variables.scss";

const Home = () => {
    // prettier-ignore
    const c = [
    {
      card: "nuts",
      img: nutsImg,
      colorPrimary: colorNuts,
      colorSecondary: LightenDarkenColor(colorNuts,-80),
      h1: <>Nuts</>,
      h2: <>Go nuts!</>,
      h3: (<>Roasted, smoked, <br /> salty, sweet</>),
      h4: (<>
          The case for nuts doesn't end with 
          <A h="fats.html" t="goto fats">fatty </A>
          acids, which have been shown to help lower
          cholesterol levels among many other benefits.
      </>),
      h4Src:"https://www.bodybuilding.com/content/5-nuts-that-can-revolutionize-your-diet.html",
      h4SrcTitle: "content from bodybuilding.com",
      p: (<>
          Nuts have also been shown to help provide an edge against stroke and
          type 2 diabetes, curb appetite, and encourage weight loss, as studies
          indicate that calories from nuts don't always correlate with the
          expected amount of weight gain. Nuts also give vegetarians a guiltless 
          <A h="protein.html" t="goto protein">protein</A>source that rivals any 
          meat, and they mix well any number of diverse dishes.
      </>),
      pSrc:"https://www.bodybuilding.com/content/5-nuts-that-can-revolutionize-your-diet.html",
      pSrcTitle: "content from bodybuilding.com"
    },

    {
      img: beansImg,
      colorPrimary: colorBeans,
      colorSecondary: LightenDarkenColor(colorBeans,-100),
      h1: <>Beans</>,
      h2: <>Where have you bean?</>,
      h3: <>Garbanzo, black eyed, kidney, white, mung.. so many!</>,
      h4: (<>
          You’ve got a wide variety of kinds from which to choose though, all
          chock full of healthy nutrients and <A h="protein.html" t="goto protein"> 
          protein{" "} </A>, in addition to fiber.{" "}
      </>),
      h4Src:"https://www.bodybuilding.com/fun/6-health-boosting-super-beans.html",
      h4SrcTitle: "content from bodybuilding.com",
      p: (<>
          Even prepared beans, such as baked and refried, can be bodybuilding
          friendly. Check labels on canned and prepared 
          <A h="beans.html" t="goto beans"> beans </A>
          some types can be loaded with unhealthy fats and salt, and you
          generally want to avoid canned beans that include bacon. Don’t worry
          though - with so many healthy versions available, you’ll have no
          problem choosing a bean that suits your tastes. 
      </>),
      pSrc: "https://www.muscleandfitness.com/flexonline/nutrition/beans-beans",
      pSrcTitle: "content from muscleandfitness.com"
    },

    {
      img: seedsImg,
      colorPrimary: colorSeeds,
      colorSecondary: LightenDarkenColor(colorSeeds,-80),
      h1: "Seeds",
      h2: "Grow baby!",
      h3: (<>
          Natures tiniest <br /> powersource
      </>),
      h4: (<>
          With all the buzz around the myriad health benefits of nuts, it's easy
          to overlook their even more diminutive counterparts.
      </>),
      h4Src:
        "https://www.bodybuilding.com/fun/6-health-boosting-super-seeds.html",
      h4SrcTitle: "content from bodybuilding.com",
      p: (<>
          I'm talking about seeds, which prove that big things come in small
          packages. In fact, many seeds are absolute nutritional giants! Replete
          with healthy <A h="fats.html" t="goto fats">fats</A>,
          <A h="protein.html" t="goto protein"> protein </A>
          , and a range of micronutrients, seeds can be your secret weapon to
          eating better than ever. Think of them as pint-sized foods with
          super-sized benefits.
      </>),
      pSrc:"https://www.bodybuilding.com/fun/6-health-boosting-super-seeds.html",
      pSrcTitle: "content from bodybuilding.com"
    }
  ];
    return (
        <FadeIn>
            <Nav home={true} />
            <main>
                <article className="page">
                    <Intro />
                    {c.map((card, index) => (
                        <Card
                            key={card.key}
                            img={card.img}
                            imgTitle={card.h1}
                            imgAlt={card.h1}
                            h1={card.h1}
                            h2={card.h2}
                            h3={card.h3}
                            h4={card.h4}
                            h4Src={card.h4Src}
                            h4SrcTitle={card.h4SrcTitle}
                            p={card.p}
                            pSrc={card.pSrc}
                            pSrcTitle={card.pSrcTitle}
                            borderColor={card.colorPrimary}
                            h3Color={card.colorSecondary}
                        />
                    ))}
                </article>
            </main>
        </FadeIn>
    );
};

export default Home;
